<template>
  <a
    href="#"
    class="social-btn officernd-btn"
    :style="loginButtonStyles"
    @click.prevent="showOfficeRnDFields()"
  >
    <i v-show="baseData.branding.iconVisible" class="fa fa-lock" />
    <span v-text="$t('officernd')" />
  </a>
</template>

<script>
  import { logUserAction } from '../../utils/logging'
  export default {
    name: 'OfficeRnDLogin',
    props: ['api', 'action', 'wftkn'],
    computed: {
      baseData() {
        return this.$store.state.baseData
      },
      loginButtonStyles() {
        return {
          background: this.loginButtonColor || '#636363',
          color: this.loginButtonTextColor || '#ffffff',
          'justify-content':
            this.baseData.loginOptions.styles.layout === 'app'
              ? 'center'
              : this.loginButtontextAlignment || 'flex-start',
        }
      },
      loginButtontextAlignment() {
        return this.baseData.branding.loginButtonTextAlign.value
      },
      loginButtonColor() {
        return this.baseData.loginOptions.styles.buttons.oauthButtonColor
      },
      loginButtonTextColor() {
        return this.baseData.loginOptions.styles.buttons.loginButtonsTextColor
      },
    },
    methods: {
      showOfficeRnDFields() {
        logUserAction({ type: 'click', label: 'OfficeRnD Login Button' });
        this.$eventHub.$emit('showOfficeRnD', true)
      },
    },
  }
</script>

<style>
  .officernd-btn {
    background: #636363;
  }
  .officernd-btn:hover {
    background: #636363;
  }
</style>
